export const StatsGoalTypes = [
  {key: 'first', label: 'First'},
  {key: 'e-shop', label: 'E-Shop'},
  {key: 'strategy', label: 'Strat'},
  {key: 'doubleanim', label: 'Double anim'},
  {key: 'auto', label: 'Fid auto'},
  {key: 'loyalty', label: 'Fid manuelle'},
  {key: 'opar', label: 'Opar'},
  {key: 'misc', label: 'Misc'},
];
